
const getItem = (key: string) => {
	return window.sessionStorage.getItem(key);
};

const items = () => {
	let items: any = [];
	let keys = Object.keys(window.sessionStorage);
	keys.forEach(key => {
		items.push(getItem(key));
	});
	return items;
};

const setItem = (key: string, value: string) => {
	window.sessionStorage.setItem(key, value)
};

const setItems = (items: [{ key: string, value: string }]) => {
	items.forEach(item => {
		window.sessionStorage.setItem(item.key, item.value)
	});
};

const removeItem = (key: string) => {
	window.sessionStorage.removeItem(key);
}

const removeItems = (keys: string[]) => {
	keys.forEach(key => {
		window.sessionStorage.removeItem(key);	
	});
}

const hasItem = (key: string) => {
	let keys = Object.keys(window.sessionStorage);
	return keys.some((k) => { return k === key; });
};

const clear = () => {
	window.sessionStorage.clear();
};


export const StorageHelper ={ items, getItem, setItem, setItems, removeItem, removeItems, hasItem, clear };
